export default "__VITE_ASSET__Bz3g_rsp__ 584w";